import {
  Text,
  useBreakpointDown,
  useCurrentBreakpoint,
} from '@travel-frontend/core';
import {Flex, LabelMedium} from '@travel-frontend/ui-components';
import {useTranslation} from 'next-i18next';

import {Button} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Button';
import {Container} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Container';
import {Content} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Content';
import {Headline} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Headline';
import {Image} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Image';
import {Logo} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero/components/Logo';

type Props = {
  title: string;
  subtitle: string;
  image: string;
  logo?: string;
};
export const Hero: React.FunctionComponent<Props> = ({
  title,
  subtitle,
  image,
  logo,
}) => {
  const {t} = useTranslation('upliftAds');
  const smDown = useBreakpointDown('sm');
  const currentScreen = useCurrentBreakpoint();
  const linesToTruncate = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
    xl: 2,
  }[currentScreen];
  return (
    <Flex spacing="8px">
      <Text preset="labelMedium" color="contentSecondary">
        {t('label')}
      </Text>
      <Container spacing="none">
        <Content
          direction="column"
          justifyContent="center"
          spacing={smDown ? '12px' : '16px'}
        >
          <Flex spacing={smDown ? '2px' : '4px'}>
            <Headline color="contentInversePrimary">{title}</Headline>
            <LabelMedium
              color="contentInversePrimary"
              truncate={linesToTruncate}
            >
              {subtitle}
            </LabelMedium>
          </Flex>
          <Button variant="danger">{t('button')}</Button>
        </Content>
        <Image src={image} alt="" />
        {logo && <Logo src={logo} alt="" />}
      </Container>
    </Flex>
  );
};
